import { render, staticRenderFns } from "./ChickTransferAdd.vue?vue&type=template&id=104904cf&scoped=true&"
import script from "./ChickTransferAdd.vue?vue&type=script&lang=js&"
export * from "./ChickTransferAdd.vue?vue&type=script&lang=js&"
import style0 from "./ChickTransferAdd.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "104904cf",
  null
  
)

export default component.exports